import axios from "axios";
import { toast } from "react-toastify";
import store from "../store"
import Cookies from "js-cookie";
import { apiUrl } from "./ApiUrl";
import { saveUserDetails } from "../store/actions/UserActions";

let refreshTokenPromise = null;

export async function AuthCheck(url) {
    if (refreshTokenPromise) {
        return refreshTokenPromise;
    }

    refreshTokenPromise = (async () => {
        let refreshToken = "";
        if (Cookies.get("refreshToken")) {
            refreshToken = Cookies.get("refreshToken");
        } else {
            toast.info("SESSION EXPIRED... PLEASE LOGIN");
            store.dispatch(saveUserDetails({}));
            Cookies.remove("token");
            Cookies.remove("refreshToken");
            window.location.reload();
            return null;
        }

        var headers = {
            "Content-Type": "application/json",
            Authorization: `Bearer ${refreshToken}`,
        }

        try {
            const response = await axios.get(url + apiUrl.generate_token, { headers: headers });

            // console.log("CreateAccess response...", response);

            if (response?.status == 200 || response?.status == true) {
                const accessToken = response?.data?.data?.accessToken;
                // console.log("Access Token:::::  ", accessToken);
                Cookies.set("token", accessToken);
                return accessToken;
            } else {
                toast.info("SESSION EXPIRED... PLEASE LOGIN");
                store.dispatch(saveUserDetails({}));
                Cookies.remove("token");
                Cookies.remove("refreshToken");
                return null;
            }

        } catch (error) {
            console.log("AuthCheck error", error);
            if (error?.response?.status === 401 || error?.response?.status === 403 || error?.response?.status === 404) {
                toast.info("SESSION EXPIRED... PLEASE LOGIN");
                store.dispatch(saveUserDetails({}));
                Cookies.remove("token");
                Cookies.remove("refreshToken");
                window.location.reload();
            }
            return null;
        } finally {
            refreshTokenPromise = null;
        }
    })();

    return refreshTokenPromise;
}
